// XO Peek Carousel
// - Dots move the track smoothly
// - Horizontal swipe (touch) moves one "page" left/right
// - Number of dots adapts to how many "pages" are visible

(function () {
  function init(root) {
    if (!root || root.dataset.xoInit === '1') return;
    root.dataset.xoInit = '1';

    const track = root.querySelector('[data-xo-track]');
    const pager = root.querySelector('[data-xo-pager]');
    const cards = track ? Array.from(track.querySelectorAll('.xo-card')) : [];
    if (!track || !pager || !cards.length) return;

    const carousel = root.querySelector('.xo-peek__carousel') || root;

    let dots = [];
    let step = 0;
    let positions = 1;
    let activeIndex = 0;

    // --- SWIPE STATE ---
    let touchStartX = 0;
    let touchStartY = 0;
    let isTouching = false;
    const SWIPE_THRESHOLD = 40; // px to trigger change

    // Distance between first two cards (includes gap)
    function computeStep() {
      if (cards.length < 2) return 0;
      return cards[1].offsetLeft - cards[0].offsetLeft;
    }

    // How many "pages" we can scroll, based on viewport width
    function computePositions() {
      if (!step) step = computeStep();
      if (!step) return 1;

      const viewportWidth = carousel.clientWidth || root.clientWidth;
      const approxVisible = Math.max(1, Math.round(viewportWidth / step)); // cards that fit
      const raw = cards.length - approxVisible; // moves we can make
      return Math.max(1, raw + 1); // +1 because index starts at 0
    }

    function setActive(index) {
      dots.forEach((btn, i) => {
        const active = i === index;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function goTo(index) {
      if (!step) step = computeStep();
      if (!step) return;

      const maxIndex = positions - 1;
      const clamped = Math.max(0, Math.min(maxIndex, index));
      const x = step * clamped;

      track.style.transform = `translateX(-${x}px)`;
      activeIndex = clamped;
      setActive(clamped);
    }

    function buildDots() {
      pager.innerHTML = '';
      dots = [];

      for (let i = 0; i < positions; i++) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'xo-pager__dot' + (i === activeIndex ? ' is-active' : '');
        btn.setAttribute('data-xo-dot', i);
        btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        btn.setAttribute('aria-current', i === activeIndex ? 'true' : 'false');

        btn.addEventListener('click', function () {
          goTo(i); // smooth slide thanks to CSS transition
        });

        pager.appendChild(btn);
        dots.push(btn);
      }
    }

    // Recalculate steps, positions, dots, and keep current slide on resize
    function refresh() {
      const prevTransition = track.style.transition;
      track.style.transition = 'none'; // avoid animated jump when resizing

      step = computeStep();
      positions = computePositions();

      if (activeIndex >= positions) activeIndex = positions - 1;
      if (activeIndex < 0) activeIndex = 0;

      buildDots();
      goTo(activeIndex);

      void track.offsetWidth; // reflow
      track.style.transition =
        prevTransition || 'transform 400ms cubic-bezier(0.22, 0.61, 0.36, 1)';
    }

    // --- TOUCH / SWIPE HANDLERS ---
    function onTouchStart(e) {
      const t = e.touches ? e.touches[0] : e;
      touchStartX = t.clientX;
      touchStartY = t.clientY;
      isTouching = true;
    }

    function onTouchMove(e) {
      if (!isTouching) return;
      const t = e.touches ? e.touches[0] : e;
      const dx = t.clientX - touchStartX;
      const dy = t.clientY - touchStartY;

      // if mostly horizontal, prevent native horizontal scroll
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) {
        e.preventDefault();
      }
    }

    function onTouchEnd(e) {
      if (!isTouching) return;
      const t = e.changedTouches ? e.changedTouches[0] : e;
      const dx = t.clientX - touchStartX;
      const dy = t.clientY - touchStartY;

      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > SWIPE_THRESHOLD) {
        if (dx < 0) {
          // swipe left -> next
          goTo(activeIndex + 1);
        } else {
          // swipe right -> previous
          goTo(activeIndex - 1);
        }
      }

      isTouching = false;
    }

    // Attach touch listeners (real devices)
    carousel.addEventListener('touchstart', onTouchStart, { passive: true });
    carousel.addEventListener('touchmove', onTouchMove, { passive: false });
    carousel.addEventListener('touchend', onTouchEnd);
    carousel.addEventListener('touchcancel', onTouchEnd);

    // Initial setup
    refresh();

    // Update on resize
    window.addEventListener('resize', refresh);
  }

  function initAll() {
    document.querySelectorAll('[data-xo-carousel]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();